<div class="form-field">
  <label class="field-label" [class.inactive]="!item.isActive" for="">
    {{ item?.feature?.name }} <span *ngIf="!item.isActive">(Pasif)</span>
  </label>


  <!-- TEXT Input -->
  <input
    *ngIf="item.feature.type === CaseFeatureTypeEnum.Text"
    type="text"
    class="form-input"
    [(ngModel)]="item.answer"
    (ngModelChange)="onValueChange($event)"
    [disabled]="!item.isActive"
    [placeholder]="'Lütfen ' + item.feature?.name?.toLowerCase() + ' giriniz'"
  />

  <!-- DATE Input -->
  <p-calendar
    *ngIf="item.feature.type === CaseFeatureTypeEnum.Date"
    [showButtonBar]="true"
    appendTo="body"
    [(ngModel)]="item.answer"
   [disabled]="!item.isActive"
    (ngModelChange)="onValueChange($event)"
  >
  </p-calendar>

  <!-- CHECKBOX Input -->
  <div
    *ngIf="item.feature.type === CaseFeatureTypeEnum.Boolean"
    class="radio-container"
  >
    <div class="radio-options">
      <div *ngFor="let option of ['EVET', 'HAYIR']" class="radio-option d-flex-between">
        <label class="radio-label w-100">
          <input
            type="radio"
            class="radio-input"
            [name]="'radio_' + item.feature.id"
            [value]="option"
            [(ngModel)]="item.answer"
            [disabled]="!item.isActive"
            (ngModelChange)="onRadioChange($event)"
          />
          <span class="radio-text">{{ getOptionLabel(option) }}</span>
        </label>
        <button class="btn btn-sm btn-outline-danger ms-2" *ngIf="item.answer==option" (click)="item.answer=null"><i class="fa fa-close"></i></button>

      </div>
    </div>
  </div>

  <!-- SELECT Input -->
  <p-dropdown
    *ngIf="item.feature.type === CaseFeatureTypeEnum.SingleSelect"
    [options]="item.feature.listOptions"
    appendTo="body"
    [(ngModel)]="item.answer"
    (ngModelChange)="onValueChange($event)"
    [disabled]="!item.isActive"
    [filter]="true"
    [showClear]="true"
  ></p-dropdown>

  <!-- MULTISELECT Input -->
  <div
    *ngIf="item.feature.type === CaseFeatureTypeEnum.MultiSelect"
    class="multiselect-container"
  >
    <p-multiSelect
      [options]="item.feature.listOptions"
      appendTo="body"
      [(ngModel)]="item.answer"
      (ngModelChange)="onValueChange($event)"
      [disabled]="!item.isActive"
      [filter]="true"
    ></p-multiSelect>
  </div>
</div>
